import {apiClient} from "@/services/client";


export const sendInquiryRequest = (form: any, lang: string) => {
    return apiClient.post(`/communication/contact?lang=${lang}`,form);
}

export const sendHelpRequest = (form: any, lang: string) => {
    return apiClient.post(`/communication/help?lang=${lang}`,form);
}


export const subscribe = (email: any, lang: string) => {

    return apiClient.post(`/communication/subscribe?lang=${lang}`,{'email': email});
}


export const getCurrencies = () => {

    return apiClient.get(`currency`);
}


